import Link from "next/link";
import Image from "next/image";
import { FiArrowRight } from "react-icons/fi";
import { Button, Card, CardBody, Col, Row } from "reactstrap";

//local imports
import classes from "@/styles/developers/overview-main.module.css";
import { overview } from "@/utils/content";
import { routes } from "@/utils/routes";
import { oImg1, oImg2, oImg3, oImg4, oImg5, oImgHero } from "@/utils/images";
import FAQAccordion from "../utils/faq-accordion";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function OverviewMain() {
  const content = overview.en;
  const isMobile = useIsMobile();
  return (
    <div className={classes.container}>
      <div className={classes.heroMain}></div>
      <section className="text-white container my-5 py-5">
        <Row>
          <Col xs={12} md={6}>
            <h1 className="fw-bold">{content.title}</h1>
            <Link
              className={`btn ${classes.btnGreen} mt-3 mb-4`}
              href={routes.becomeADeveloper}
            >
              {content.btn1Text}
            </Link>
          </Col>
          <Col className="text-center" xs={12} md={6}>
            <Image
              src={oImgHero}
              alt={oImgHero}
              className="img-fluid"
              height={400}
              width={450}
            />
          </Col>
        </Row>
      </section>
      <section className="my-5 container">
        <div className="text-center">
          <h3 className={classes.h3}>{content.title2}</h3>
          <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
            <Button className={classes.tabBtnGray}>{content.rates}</Button>
            <Button className={classes.tabBtnGray}>{content.labels}</Button>
            <Button className={classes.tabBtnBlue}>{content.orders}</Button>
            <Button className={classes.tabBtnBlue}>{content.profiles}</Button>
            <Button className={classes.tabBtnBlue}>{content.purchases}</Button>
            <Button className={classes.tabBtnBlue}>{content.products}</Button>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3 flex-wrap">
            <Button className={classes.tabBtnBlue}>{content.shipments}</Button>
            <Button className={classes.tabBtnBlue}>{content.stats}</Button>
            <Button className={classes.tabBtnBlue}>{content.other}</Button>
          </div>
        </div>
      </section>
      <section className={`${isMobile ? "" : "my-5 py-5"} container`}>
        <Row>
          <Col xs={12} md={6}>
            <h3 className={classes.h3}>{content.title3}</h3>
            <p>{content.para3}</p>
          </Col>
          <Col xs={12} md={6}>
            <Card className={classes.card}>
              <CardBody>
                <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                  <Image
                    className={`img-fluid ${classes.smallImg}`}
                    src={oImg1}
                    alt={oImg1}
                    height={45}
                    width={45}
                  />
                  <Image
                    className={`img-fluid ${classes.smallImg}`}
                    src={oImg2}
                    alt={oImg2}
                    height={45}
                    width={45}
                  />
                  <Image
                    className={`img-fluid ${classes.smallImg}`}
                    src={oImg3}
                    alt={oImg3}
                    height={45}
                    width={45}
                  />
                  <Image
                    className={`img-fluid ${classes.smallImg}`}
                    src={oImg4}
                    alt={oImg4}
                    height={45}
                    width={45}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </section>
      <section className={`${isMobile ? "" : "my-5 py-5"} container`}>
        <Row>
          <Col className="pt-5" xs={12} md={6}>
            <h3 className={`${classes.h3} mt-5 pt-3`}>{content.title4}</h3>
            <p>{content.para4}</p>
          </Col>
          <Col className="text-center" xs={12} md={6}>
            <Image
              src={oImg5}
              className="img-fluid p-2"
              alt={oImg5}
              height={350}
              width={300}
            />
          </Col>
        </Row>
      </section>
      <section
        className={`${isMobile ? "" : "mt-5"} py-5 ${
          classes.benefitsContainer
        }`}
      >
        <div className="container">
          <Row>
            <Col xs={12} md={6}>
              <h3 className={classes.h3}>{content.title5}</h3>
              <p className="w-75">{content.para5}</p>
              <Link
                className={`btn mt-3 mb-3 ${classes.btnDarkGreen}`}
                href={routes.becomeADeveloper}
              >
                {content.btn1Text}
              </Link>
            </Col>
            <Col xs={12} md={6}>
              <div className="d-flex gap-3">
                <FiArrowRight size={26} />
                <div>
                  <h5 className={classes.h5}>{content.subHeading1}</h5>
                  <p className={classes.p}>{content.subPara1}</p>
                </div>
              </div>
              <div className="d-flex gap-3">
                <FiArrowRight size={36} />
                <div>
                  <h5 className={classes.h5}>{content.subHeading2}</h5>
                  <p className={classes.p}>{content.subPara2}</p>
                </div>
              </div>
              <div className="d-flex gap-3">
                <FiArrowRight size={36} />
                <div>
                  <h5 className={classes.h5}>{content.subHeading3}</h5>
                  <p className={classes.p}>{content.subPara3}</p>
                </div>
              </div>
              <div className="d-flex gap-3">
                <FiArrowRight size={26} />
                <div className={classes.h5}>
                  <h5>{content.subHeading4}</h5>
                  <p className={classes.p}>{content.subPara4}</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="my-5 py-5 container">
        <h3 className={`${classes.h3} text-center`}>{content.title6}</h3>
        <FAQAccordion faqList={content.faq} />
      </section>
    </div>
  );
}
